/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import useUser from '../../../../Shared/UserProvider/useUser'
import { getCheckoutSystem } from '../../../../../services/PointOfSale/PointOfSale.service'
import { useTranslation } from 'react-i18next'
import { Icon, IconGroup } from 'semantic-ui-react'
import { NoCheckoutSystemCardContent } from './NoCheckoutSystemCardContent'
import { TIME } from '../../../../../services/date.service'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import formatDate from '../../../../../helpers/formatDate'
import { THEME_COLORS } from '../../../../Shared/theme'


const CheckoutSystemCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['checkout-system', user.provider.object.id],
        queryFn: () => getCheckoutSystem(user.provider.object.id),
        staleTime: TIME.MINUTE_IN_MS * 5,
    })

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        if (!data || data.state === undefined) {
            return 'grey'
        }

        return data.state.status === 'OK' ? THEME_COLORS.GREEN : THEME_COLORS.RED
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};
            .card-content {
                width: 265px;
                height: 110px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : !data ? <NoCheckoutSystemCardContent/> : (
            (
              <CardContent
                css={css`
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    flex-direction: column;
                    padding: 1rem;
                    width: 100%;
                `}
              >
                  <div
                    css={css`
                        display: flex;
                        align-items: center;
                        column-gap: .5rem;
                        margin-bottom: 1rem;
                    `}
                  >
                      <IconGroup size="big">
                          <Icon color="grey" name="plug"/>
                          <Icon
                            corner
                            name={(data.state === undefined || data.state.status === 'OK') ? 'checkmark' : 'ban'}
                            color={(data.state === undefined || data.state.status === 'OK') ? 'green' : 'red'}
                          />
                      </IconGroup>
                      <p
                        css={css`
                            margin-right: .5rem;
                            font-weight: bold;
                        `}>
                          {t('checkout_system.checkout_system', { moduleName: data?.name })}
                      </p>
                  </div>
                  {data.state?.sentAt &&
                    <p>
                        {t('checkout_system.state.lastSentAt')}<br />
                        <b>{formatDate(data.state.sentAt)}</b>
                    </p>
                  }
              </CardContent>
            )
          )}
      </Card>
    )
}

export { CheckoutSystemCard }
